/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as c from "react";
import e from "prop-types";
import { classNames as a } from "@progress/kendo-react-common";
const i = (n) => {
  const s = {
    layout: "end",
    ...n
  }, { layout: t, children: o } = s, r = a(
    "k-actions",
    "k-window-actions",
    "k-actions-horizontal",
    "k-hstack",
    {
      "k-justify-content-start": t === "start",
      "k-justify-content-center": t === "center",
      "k-justify-content-end": t === "end",
      "k-justify-content-stretch": t === "stretched"
    }
  );
  return /* @__PURE__ */ c.createElement("div", { className: r }, o);
};
i.propTypes = {
  children: e.any,
  layout: e.oneOf(["start", "center", "end", "stretched"])
};
export {
  i as WindowActionsBar
};
